export default __webpack_public_path__ + "static/media/car-meet-app.bca1ac9f.png";